import { render, staticRenderFns } from "./LoadingPadraoContainer.vue?vue&type=template&id=e4f06cf4&scoped=true&"
import script from "./LoadingPadraoContainer.vue?vue&type=script&lang=js&"
export * from "./LoadingPadraoContainer.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPadraoContainer.vue?vue&type=style&index=0&id=e4f06cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f06cf4",
  null
  
)

export default component.exports